import * as React from 'react';
import styled from 'styled-components';
import { space, color, themeGet } from 'styled-system';
import { Image } from 'react-feather';

import { UploaderCrop as Uploader, Modal } from '.';
import { SteynCityContext } from './ContextProvider';
import { StyledSystemProps } from '../theme/StyledSystemProps';
import ImageOverlay, { Overlay } from './ImageOverlay';

const ImageContainer = styled.img`
  height: ${(props) => props.height || 'auto'};
  display: block;
  max-width: 100%;
  position: relative;
  border-radius: 4px;
`;

const Wrapper = styled.div<StyledSystemProps>`
  ${space};
  display: flex;
  overflow: hidden;
  flex-flow: column;
  position: relative;
  border-radius: 4px;
  box-sizing: border-box;
  border: 1px solid ${themeGet('colors.paleGrey', '#EEE')};
  &:hover ${Overlay} {
    bottom: 0;
    opacity: 1;
    pointer-events: all;
    transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  }
`;

const Placeholder = styled.div<StyledSystemProps>`
  ${color};
  width: ${(props) => props.width || '100%'};
  height: ${(props) => props.height || '300px'};
  display: flex;
  align-items: center;
  justify-content: center;
`;

interface ImageObject {
  scaled: string;
  // Add other properties that might be in the response.body
}

type Props = StyledSystemProps & {
  src?: string;
  color?: string;
  onUploadComplete: (data: ImageObject | null) => void;
  uploadText?: string;
  height?: any;
  className?: string;
  allowedFileTypes?: string[];
  modalHeading?: string;
};

const NewHeroImage: React.FC<Props> = (props) => {
  const [modalVisible, setModalVisible] = React.useState(false);
  const [imageSrc, setImageSrc] = React.useState(props.src || '');
  const context = React.useContext(SteynCityContext);
  const { onUploadComplete, width, height, uploadText, className, allowedFileTypes, modalHeading } = props;

  React.useEffect(() => {
    if (props.src) {
      setImageSrc(props.src);
    }
  }, [props.src]);

  const handleUploadSuccess = (data: any) => {
    if (!data) {
      context.addToast('Sorry, something went wrong.', 'ERROR');
      return;
    }
    setModalVisible(false);
    setImageSrc(data.scaled || data.original);
    context.addToast('Image added successfully.', 'SUCCESS');
    onUploadComplete(data);
  };

  return (
    <React.Fragment>
      <Modal open={modalVisible} onClose={() => setModalVisible(false)} heading={modalHeading || 'Upload Image'}>
        <Uploader
          onComplete={handleUploadSuccess}
          handleUploadSuccess={handleUploadSuccess}
          allowedFileTypes={allowedFileTypes || ['image/*']}
        />
      </Modal>
      <Wrapper mb={4} className={className}>
        {imageSrc ? (
          <React.Fragment>
            <ImageContainer src={imageSrc} height={height} />
            <ImageOverlay onClick={() => setModalVisible(true)} uploadText="EDIT" edit={true} />
          </React.Fragment>
        ) : (
          <>
            <Placeholder width={width} height={height} bg="transparentBlack">
              <Image size={80} color="white" />
            </Placeholder>
            <ImageOverlay uploadText={uploadText || 'ADD PHOTO'} onClick={() => setModalVisible(true)} />
          </>
        )}
      </Wrapper>
    </React.Fragment>
  );
};

export default NewHeroImage;



// WEBPACK FOOTER //
// ./src/components/NewHeroImageCrop.tsx